import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SwiperOptions } from 'swiper/types/swiper-options';

export interface GalleryImage {
  src: string;
  alt: string;
}

@Component({
  selector: 'ui-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageGalleryComponent implements AfterViewInit {
  /** https://swiperjs.com/swiper-api */
  @Input()
  public config: SwiperOptions = {};
  @Input()
  public slides: Array<GalleryImage> = [];

  @ViewChild('imageGallery', { read: ElementRef })
  private _imageGallery!: ElementRef;

  public ngAfterViewInit(): void {
    if (this._imageGallery && this.slides.length > 0) {
      Object.assign(this._imageGallery.nativeElement, this.config);
      setTimeout(() => {
        this._imageGallery?.nativeElement?.initialize();
      });
    }
  }
}
